import styled from "styled-components";
import { useState, useRef, useEffect } from "react";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

const EmailsEditWrapper = styled.div`
  .add-email {
    font-size: 10px;
    margin-left: 5px;
    color: green;
    cursor: pointer;
    margin-top: 0;
  }
  .add-email:hover {
    color: #005900;
  }
`;

const EmailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  i {
    margin: 0 8px;
  }
`;

export default function EmailEdit({ user, setUser }: Props) {
  const [emailPopUpVisible, setEmailPopUpVisible] = useState(false);
  const buttonEl = useRef<HTMLElement | null>(null);

  const onEmailDelete = (e: any) => {
    const emailIndex = e.target.id.split("-")[0];
    if (user.email.length <= 1) {
      setEmailPopUpVisible(true);
    } else {
      const newEmails = [...user.email];
      newEmails.splice(emailIndex, 1);
      setUser({
        ...user,
        email: newEmails
      });
    }
  };

  const addEmail = () => {
    const newEmails = [...user.email];
    newEmails.push("");
    setUser({ ...user, email: newEmails });
  };

  const inputChange = (e: any) => {
    if (e.target.id.includes("email")) {
      const emailIndex = e.target.id.split("-")[0];
      const newEmails = [...user.email];
      newEmails[emailIndex] = e.target.value.toLowerCase();
      setUser({ ...user, email: newEmails });
    }
  };

  return (
    <EmailsEditWrapper>
      {user.email.map((email, index) => (
        <EmailRow key={`${index}-row-${user.userId}`}>
          <InputText
            id={`${index}-email-${user.userId}`}
            key={`${index}-email-${user.userId}`}
            onChange={(e) => inputChange(e)}
            value={email}
          />
          <i
            ref={buttonEl}
            onClick={onEmailDelete}
            id={`${index}-delete-${user.userId}`}
            key={`${index}-delete-${user.userId}`}
            className="pi pi-times"
            style={{ color: "red" }}
          ></i>
          <ConfirmPopup
            target={buttonEl.current || undefined}
            visible={emailPopUpVisible}
            onHide={() => setEmailPopUpVisible(false)}
            message="You need at least one email adresse."
            icon="pi pi-exclamation-triangle"
            accept={() => setEmailPopUpVisible(false)}
            footer={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "10px",
                }}
              >
                <Button
                  label="Ok"
                  onClick={() => {
                    setEmailPopUpVisible(false);
                  }}
                />
              </div>
            }
          />
        </EmailRow>
      ))}
      <p className="add-email" onClick={addEmail}>
        Add Email
        <i
          className="pi pi-plus"
          style={{
            color: "green",
            fontSize: "7px",
            fontWeight: "bold",
            marginLeft: "3px",
          }}
        ></i>
      </p>
    </EmailsEditWrapper>
  );
}

interface Props {
  user: UserData;
  setUser: (user: UserData) => void;
}
